/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type AllergenRelation = {
    id: string;
    contains: AllergenRelation.contains;
};

export namespace AllergenRelation {

    export enum contains {
        NO = 'No',
        MAY = 'May',
        YES = 'Yes',
    }


}

